import { createReducer } from 'redux-act';

/**
 * Import actions
 */

import {
    filterLevelChange,
    filterTypeChange,
    filterNameChange,
    filterMinTimeChange,
    filterMaxTimeChange,
    filterSortChange,
    filterLoadExisting
} from 'actions/filter';

/**
 * Create reducer
 */

// Specify default state
const defaultState = {
    levels: [],
    types: [],
    name: '',
    minTime: 5,
    maxTime: 120,
    sort: 'level',

};

const filter = createReducer({


    [filterMinTimeChange]: (state, payload) => ({
        ...state,
        minTime: payload
    }),

    [filterMaxTimeChange]: (state, payload) => ({
        ...state,
        maxTime: payload
    }),

    [filterLevelChange]: (state, payload) => ({
        ...state,
        levels: payload
    }),

    [filterTypeChange]: (state, payload) => ({
        ...state,
        types: payload
    }),

    [filterNameChange]: (state, payload) => ({
        ...state,
        name: payload
    }),
    [filterSortChange]: (state, payload) => ({
        ...state,
        sort: payload
    }),
    [filterLoadExisting]: (state, payload) => ({
        ...state,
        ...payload.filters
    }),
    

}, defaultState);

export default filter;
